import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container, Typography, Box, Paper, Chip, Button,
} from '@mui/material';
import GavelIcon from '@mui/icons-material/Gavel';
import PersonIcon from '@mui/icons-material/Person';
import StorefrontIcon from '@mui/icons-material/Storefront';
import PaymentIcon from '@mui/icons-material/Payment';
import BlockIcon from '@mui/icons-material/Block';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import BuildIcon from '@mui/icons-material/Build';
import WarningIcon from '@mui/icons-material/Warning';
import UpdateIcon from '@mui/icons-material/Update';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const C = {
  purple: '#552583', purpleDark: '#33154f', gold: '#FDB927',
  bg: '#E4F0F6', white: '#ffffff', text: '#1a1a1a', textSoft: '#4a4a4a', textMuted: '#7a7a7a',
};

const sections = [
  { id: 'objet',         label: 'Objet',           icon: <GavelIcon sx={{ fontSize: 18 }} /> },
  { id: 'inscription',   label: 'Inscription',     icon: <PersonIcon sx={{ fontSize: 18 }} /> },
  { id: 'services',      label: 'Services',        icon: <StorefrontIcon sx={{ fontSize: 18 }} /> },
  { id: 'commandes',     label: 'Commandes',       icon: <DeliveryDiningIcon sx={{ fontSize: 18 }} /> },
  { id: 'paiement',      label: 'Paiement',        icon: <PaymentIcon sx={{ fontSize: 18 }} /> },
  { id: 'obligations',   label: 'Obligations',     icon: <BuildIcon sx={{ fontSize: 18 }} /> },
  { id: 'responsabilite',label: 'Responsabilité',  icon: <WarningIcon sx={{ fontSize: 18 }} /> },
  { id: 'interdictions', label: 'Interdictions',   icon: <BlockIcon sx={{ fontSize: 18 }} /> },
  { id: 'modifications', label: 'Modifications',   icon: <UpdateIcon sx={{ fontSize: 18 }} /> },
  { id: 'contact',       label: 'Contact',         icon: <ContactMailIcon sx={{ fontSize: 18 }} /> },
];

const sectionContent = [
  {
    id: 'objet',
    title: '1. Objet et acceptation',
    icon: <GavelIcon sx={{ fontSize: 28, color: C.purple }} />,
    content: [
      {
        subtitle: 'Objet',
        text: 'Les présentes Conditions Générales d\'Utilisation (CGU) régissent l\'accès et l\'utilisation de la plateforme Usafiri, accessible à l\'adresse usafiri.yt, ainsi que l\'ensemble des services proposés : restauration, covoiturage, location de véhicules, livraison, logistique et courses.',
      },
      {
        subtitle: 'Acceptation',
        text: 'En accédant à la plateforme ou en créant un compte, vous acceptez sans réserve les présentes CGU. Si vous n\'acceptez pas ces conditions, vous ne devez pas utiliser la plateforme.',
      },
      {
        subtitle: 'Droit applicable',
        text: 'Les présentes CGU sont soumises au droit français. Tout litige sera soumis à la compétence des tribunaux de Mamoudzou (Mayotte, 976).',
      },
    ],
  },
  {
    id: 'inscription',
    title: '2. Inscription et compte utilisateur',
    icon: <PersonIcon sx={{ fontSize: 28, color: C.purple }} />,
    content: [
      {
        subtitle: 'Création de compte',
        text: 'L\'utilisation de certains services nécessite la création d\'un compte. Vous devez fournir des informations exactes et complètes (nom, prénom, adresse email, numéro de téléphone). Vous êtes responsable de la confidentialité de vos identifiants de connexion.',
      },
      {
        subtitle: 'Conditions d\'âge',
        text: 'Vous devez être âgé d\'au moins 18 ans pour créer un compte et utiliser les services de la plateforme. Les mineurs ne peuvent pas s\'inscrire ni effectuer de transactions.',
      },
      {
        subtitle: 'Suspension et suppression',
        text: 'Usafiri se réserve le droit de suspendre ou supprimer tout compte en cas de violation des présentes CGU, d\'activité frauduleuse ou d\'utilisation abusive de la plateforme, après notification préalable sauf urgence.',
      },
    ],
  },
  {
    id: 'services',
    title: '3. Description des services',
    icon: <StorefrontIcon sx={{ fontSize: 28, color: C.purple }} />,
    content: [
      {
        subtitle: 'Restauration',
        text: 'Usafiri permet de commander des repas auprès de restaurants partenaires, avec livraison à domicile ou retrait en Click & Collect. Les prix affichés sont fixés par les restaurateurs partenaires.',
      },
      {
        subtitle: 'Covoiturage',
        text: 'La plateforme met en relation des conducteurs et des passagers pour des trajets partagés à Mayotte. Le prix par place est fixé par le conducteur dans les limites légales du partage de frais.',
      },
      {
        subtitle: 'Location de véhicules',
        text: 'Usafiri propose la mise en relation entre propriétaires de véhicules et locataires. Les conditions de location (prix, durée, assurance) sont définies par le propriétaire.',
      },
      {
        subtitle: 'Livraison et logistique',
        text: 'Les services de livraison express et de logistique permettent l\'envoi de colis sur le territoire de Mayotte. Les tarifs de livraison sont calculés selon la distance.',
      },
    ],
  },
  {
    id: 'commandes',
    title: '4. Commandes et livraison',
    icon: <DeliveryDiningIcon sx={{ fontSize: 28, color: C.purple }} />,
    content: [
      {
        subtitle: 'Passation de commande',
        text: 'Toute commande passée sur la plateforme constitue un contrat de vente entre vous et le partenaire concerné (restaurant, loueur, etc.). Usafiri agit en tant qu\'intermédiaire technique.',
      },
      {
        subtitle: 'Délais de livraison',
        text: 'Les délais de livraison sont indicatifs et peuvent varier en fonction des conditions de circulation, de la météo ou de la disponibilité des livreurs. Usafiri s\'efforce de respecter les estimations communiquées.',
      },
      {
        subtitle: 'Annulation',
        text: 'Une commande peut être annulée avant sa confirmation par le partenaire. Après confirmation, l\'annulation est soumise aux conditions du partenaire. Un remboursement sera effectué si l\'annulation est acceptée.',
      },
    ],
  },
  {
    id: 'paiement',
    title: '5. Paiement et tarification',
    icon: <PaymentIcon sx={{ fontSize: 28, color: C.purple }} />,
    content: [
      {
        subtitle: 'Moyens de paiement',
        text: 'Les paiements sont effectués par carte bancaire via la plateforme sécurisée Stripe. Usafiri ne stocke aucune donnée de carte bancaire. Les transactions sont chiffrées et conformes aux normes PCI-DSS.',
      },
      {
        subtitle: 'Frais de livraison',
        text: 'Les frais de livraison sont calculés selon la distance entre le point de retrait et l\'adresse de livraison, au tarif de 2,50 EUR par tranche de 5 km. Ils sont clairement indiqués avant la validation de la commande.',
      },
      {
        subtitle: 'Remboursements',
        text: 'En cas d\'annulation éligible ou de problème avec une commande, le remboursement est effectué sur le moyen de paiement utilisé, dans un délai de 5 à 10 jours ouvrables selon votre banque.',
      },
    ],
  },
  {
    id: 'obligations',
    title: '6. Obligations des utilisateurs',
    icon: <BuildIcon sx={{ fontSize: 28, color: C.purple }} />,
    content: [
      {
        subtitle: 'Clients',
        text: 'Les clients s\'engagent à fournir des informations exactes, à être présents pour recevoir leur livraison, à respecter les livreurs et partenaires, et à signaler tout problème via la plateforme.',
      },
      {
        subtitle: 'Partenaires',
        text: 'Les partenaires (restaurants, loueurs, conducteurs) s\'engagent à respecter la réglementation en vigueur, à fournir des produits/services conformes à leur description, et à honorer les commandes acceptées.',
      },
      {
        subtitle: 'Livreurs',
        text: 'Les livreurs doivent disposer d\'un statut légal d\'auto-entrepreneur ou équivalent, respecter le code de la route, manipuler les commandes avec soin, et fournir un KBIS valide dans les délais impartis.',
      },
    ],
  },
  {
    id: 'responsabilite',
    title: '7. Limitation de responsabilité',
    icon: <WarningIcon sx={{ fontSize: 28, color: C.purple }} />,
    content: [
      {
        subtitle: 'Rôle d\'intermédiaire',
        text: 'Usafiri agit en tant qu\'intermédiaire technique entre les utilisateurs et les partenaires. La plateforme n\'est pas partie au contrat de vente entre le client et le partenaire.',
      },
      {
        subtitle: 'Disponibilité',
        text: 'Usafiri s\'efforce d\'assurer la disponibilité de la plateforme 24h/24 et 7j/7, mais ne garantit pas une disponibilité ininterrompue. Des interruptions pour maintenance ou mises à jour peuvent survenir.',
      },
      {
        subtitle: 'Qualite des produits',
        text: 'La qualité des produits et services fournis par les partenaires relève de leur seule responsabilité. Usafiri s\'engage cependant à traiter toute réclamation et à prendre les mesures appropriées.',
      },
    ],
  },
  {
    id: 'interdictions',
    title: '8. Utilisations interdites',
    icon: <BlockIcon sx={{ fontSize: 28, color: C.purple }} />,
    content: [
      {
        subtitle: 'Comportements interdits',
        text: 'Sont strictement interdits : la création de faux comptes, l\'utilisation frauduleuse de moyens de paiement, le harcèlement ou l\'intimidation d\'autres utilisateurs, partenaires ou livreurs, et toute tentative de contourner les systèmes de sécurité de la plateforme.',
      },
      {
        subtitle: 'Contenu',
        text: 'Il est interdit de publier du contenu illégal, diffamatoire, discriminatoire ou portant atteinte aux droits de tiers. Usafiri se réserve le droit de supprimer tout contenu inapproprié sans préavis.',
      },
    ],
  },
  {
    id: 'modifications',
    title: '9. Modifications des CGU',
    icon: <UpdateIcon sx={{ fontSize: 28, color: C.purple }} />,
    content: [
      {
        subtitle: 'Évolution',
        text: 'Usafiri se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs seront informés par email ou notification sur la plateforme au moins 15 jours avant l\'entrée en vigueur des modifications.',
      },
      {
        subtitle: 'Continuité d\'utilisation',
        text: 'La poursuite de l\'utilisation de la plateforme après la date d\'entrée en vigueur des nouvelles CGU vaut acceptation de celles-ci.',
      },
    ],
  },
  {
    id: 'contact',
    title: '10. Contact',
    icon: <ContactMailIcon sx={{ fontSize: 28, color: C.purple }} />,
    content: [
      {
        subtitle: 'Service client',
        text: 'Pour toute question relative aux présentes CGU ou à l\'utilisation de la plateforme, contactez-nous à : contact@usafiri.yt',
      },
      {
        subtitle: 'Réclamations',
        text: 'Toute réclamation doit être adressée par email à contact@usafiri.yt. Nous nous engageons à vous répondre dans un délai de 48 heures ouvrables.',
      },
      {
        subtitle: 'Médiation',
        text: 'Conformément aux articles L.612-1 et suivants du Code de la consommation, en cas de litige non résolu, vous pouvez recourir gratuitement au service de médiation. Les coordonnées du médiateur seront communiquées sur demande.',
      },
    ],
  },
];

export default function CGU() {
  const navigate = useNavigate();
  const [active, setActive] = useState('objet');

  const scrollTo = (id) => {
    setActive(id);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <Box sx={{ background: C.bg, minHeight: '100vh' }}>
      {/* Hero */}
      <Box sx={{
        background: `linear-gradient(135deg, ${C.purpleDark} 0%, ${C.purple} 60%, #7a3aad 100%)`,
        color: C.white, py: { xs: 6, md: 10 }, px: 2, textAlign: 'center',
        position: 'relative', overflow: 'hidden',
      }}>
        <Box sx={{ position: 'absolute', top: -60, right: -60, width: 220, height: 220, borderRadius: '50%', background: 'rgba(253,185,39,0.08)', pointerEvents: 'none' }} />
        <Box sx={{ position: 'absolute', bottom: -40, left: -40, width: 160, height: 160, borderRadius: '50%', background: 'rgba(255,255,255,0.05)', pointerEvents: 'none' }} />

        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
          <Box sx={{
            width: 72, height: 72, borderRadius: '20px',
            background: 'rgba(253,185,39,0.15)', border: '1.5px solid rgba(253,185,39,0.3)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <GavelIcon sx={{ fontSize: 38, color: C.gold }} />
          </Box>
        </Box>

        <Typography variant="h3" fontWeight={800} sx={{ mb: 1.5, fontSize: { xs: '1.8rem', md: '2.6rem' }, letterSpacing: '-0.5px' }}>
          Conditions Générales d'Utilisation
        </Typography>
        <Typography variant="body1" sx={{ opacity: 0.75, mb: 3, maxWidth: 500, mx: 'auto' }}>
          Règles d'utilisation de la plateforme Usafiri
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
          <Chip label="Mise à jour : mai 2025" sx={{ bgcolor: 'rgba(255,255,255,0.12)', color: 'white', fontWeight: 600, fontSize: '0.75rem' }} />
          <Chip label="Droit français" sx={{ bgcolor: 'rgba(253,185,39,0.18)', color: C.gold, fontWeight: 700, fontSize: '0.75rem', border: '1px solid rgba(253,185,39,0.3)' }} />
        </Box>
      </Box>

      <Container maxWidth="lg" sx={{ py: { xs: 4, md: 7 } }}>
        {/* Navigation rapide */}
        <Paper elevation={0} sx={{
          mb: 5, p: 2.5, borderRadius: '16px', background: C.white,
          border: '1px solid rgba(85,37,131,0.1)', boxShadow: '0 4px 20px rgba(85,37,131,0.06)',
        }}>
          <Typography variant="body2" fontWeight={700} sx={{ color: C.purple, mb: 1.5, fontSize: '0.7rem', letterSpacing: '0.08em' }}>
            NAVIGATION RAPIDE
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {sections.map((s) => (
              <Chip key={s.id} icon={s.icon} label={s.label} onClick={() => scrollTo(s.id)}
                sx={{
                  cursor: 'pointer', fontWeight: 600, fontSize: '0.78rem', borderRadius: '10px',
                  bgcolor: active === s.id ? C.purple : 'rgba(85,37,131,0.06)',
                  color: active === s.id ? C.white : C.purple,
                  border: active === s.id ? 'none' : '1px solid rgba(85,37,131,0.12)',
                  '& .MuiChip-icon': { color: active === s.id ? C.gold : C.purple },
                  transition: 'all 0.2s',
                  '&:hover': { bgcolor: active === s.id ? C.purpleDark : 'rgba(85,37,131,0.12)' },
                }}
              />
            ))}
          </Box>
        </Paper>

        {/* Sections */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          {sectionContent.map((section) => (
            <Paper key={section.id} id={section.id} elevation={0} sx={{
              borderRadius: '20px', background: C.white,
              border: '1px solid rgba(85,37,131,0.08)', boxShadow: '0 4px 24px rgba(85,37,131,0.06)',
              overflow: 'hidden', scrollMarginTop: '80px',
            }}>
              <Box sx={{
                display: 'flex', alignItems: 'center', gap: 2,
                p: { xs: 2.5, md: 3.5 },
                background: 'linear-gradient(135deg, rgba(85,37,131,0.04) 0%, rgba(253,185,39,0.04) 100%)',
                borderBottom: '1px solid rgba(85,37,131,0.08)',
              }}>
                <Box sx={{
                  width: 48, height: 48, borderRadius: '14px',
                  background: 'rgba(85,37,131,0.08)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  {section.icon}
                </Box>
                <Typography variant="h6" fontWeight={700} sx={{ color: C.text }}>
                  {section.title}
                </Typography>
              </Box>

              <Box sx={{ p: { xs: 2.5, md: 3.5 }, display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                {section.content.map((item, i) => (
                  <Box key={i}>
                    <Typography variant="subtitle2" fontWeight={700} sx={{ color: C.purple, mb: 0.5, fontSize: '0.85rem' }}>
                      {item.subtitle}
                    </Typography>
                    <Typography variant="body2" sx={{ color: C.textSoft, lineHeight: 1.8, whiteSpace: 'pre-line' }}>
                      {item.text}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Paper>
          ))}
        </Box>

        <Box sx={{ mt: 5, textAlign: 'center' }}>
          <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={() => navigate(-1)}
            sx={{ borderColor: C.purple, color: C.purple, borderRadius: '12px', textTransform: 'none', fontWeight: 600,
              '&:hover': { borderColor: C.purpleDark, bgcolor: 'rgba(85,37,131,0.04)' },
            }}>
            Retour
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
